import React, { FC, useState } from 'react';

import styled from 'styled-components';

import Markdown from '@components/utils/Markdown';
import { Separator } from '@components/formStyles';
import { SectionHeading } from '@shared/SectionHeading';

export const Container = styled.div`
  width: 100%;
  height: auto;
  border-radius: 0;
  color: ${({ theme }) => theme.palette.darkGrey};
  margin-top: 24px;
  background-color: transparent;
  position: relative;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 15px;
  }
`;

export const Title = styled(SectionHeading)`
  display: block;
  margin-bottom: 0;
`;

export const ReadMore = styled.button`
  border: 0;
  padding: 0;
  background: transparent;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.primaryBrand};
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ContainerText = styled.div<{ $collapsed?: boolean }>`
  ${({ $collapsed }) =>
    $collapsed
      ? `
          display: -webkit-box;
          -webkit-line-clamp: 5;
          -webkit-box-orient: vertical;
          overflow: hidden;
        `
      : ''}

  & span,
  & p {
    font-size: 16px !important;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    & span,
    & p {
      font-size: 14px !important;
    }
  }
`;

export const ConditionsNoteContainer = styled.div`
  width: fit-content;
  min-height: 48px;
  max-height: 84px;
  height: auto;
  padding: 15px 12px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.lightYellow};
  color: ${({ theme }) => theme.palette.primaryBrand};
  text-align: left;
  border: dashed 0.5px;
  border-radius: 2px;
  font-weight: 600;
  font-size: 14px;
`;

export interface TourDetailContentProps {
  title: string;
  description?: string;
}

const LIMIT = 500;

const ReadMoreSection: FC<{ text: string; onClick?: () => void }> = ({
  text,
  onClick,
}) => <ReadMore onClick={onClick}>{text}</ReadMore>;

const TourDetailContent: FC<TourDetailContentProps> = ({
  title,
  description,
}) => {
  const [isReadMore, setIsReadMore] = useState(false);
  const onReadMore = () => setIsReadMore((current) => !current);
  const isCollapsed = Boolean(
    description && description.length > LIMIT && !isReadMore
  );

  return description?.trim() ? (
    <Container>
      <Title>{title}</Title>
      <Separator size='12px' />

      {title === 'Genel Şartlar' ? (
        <ConditionsNoteContainer>
          Genel Şartlar tur programının ayrılmaz bir parçasıdır ve tur
          programından bağımsız düşünülemez.
        </ConditionsNoteContainer>
      ) : null}

      <Separator size='12px' />

      <ContainerText $collapsed={isCollapsed}>
        <Markdown text={description} />
      </ContainerText>
      {description.length > LIMIT ? (
        <ReadMoreSection
          text={!isReadMore ? 'Devamını Oku' : 'Daha az göster'}
          onClick={onReadMore}
        />
      ) : null}
    </Container>
  ) : null;
};

export default TourDetailContent;
